import styled from "styled-components";

const Container = styled.section`
    padding: 25px;
    background-color: #1571B3;

    h1 {
        font-size: xx-large;
    }

    h2 {
        font-size: x-large;
    }

    h3 {
        font-size: larger;
    }

    p {
        font-weight: 500;
    }
`;

export {
    Container
};